import type { FC } from "react";

import { PageContent } from "@shared/components";

const SkeletonCatalogPage: FC = () => <PageContent />;

export { SkeletonCatalogPage };
